import JiayaoAdapter from './jiayaoAdapter';
import SilvergateAdapter from './silvergateAdapter';
export default function getExecelDataAdapter(data) {
  const jiayaoKeys = [
    'Order Name', 'Order Number',
    'Billing First Name', 'Billing Last Name', 'Billing Phone',
    'Fulfillment First Name', 'Fulfillment Last Name', 'Fulfillment Email', 'Fulfillment Phone',
    'Fulfillment Address 1', 'Fulfillment Zipcode', 'Fulfillment District', 'Fulfillment Province',
    'Item Name', 'Item Variant', 'Item Properties', 'Item Price', 'Quantity',
    'Fulfillment Location'];
  if (jiayaoKeys.every((key) => key in data[0]) && data[0]['Fulfillment Location'] === '富餚生鮮有限公司') {
    return new JiayaoAdapter(data);
  }
  const silvergateKeys = [
    '訂單編號', '送餐時間', '送餐對象身分證字號', '餐廳', '餐點名稱', '餐點數量', '餐點備註', '送餐大使姓名', '送餐費用', '送餐備註',
  ];
  if (silvergateKeys.every((key) => key in data[0])) {
    return new SilvergateAdapter(data);
  }
  return;
}
